"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/journeyService',["require", "exports", "models/userIdentityModel", "controllers/journeyController", "routing/mainRouter", "viewModels/policyViewModel", "moment"], function (require, exports, userIdentityModel, journeyController, mainRouter, policyViewModel, moment) {
    "use strict";

    var JourneyService = function () {
        function JourneyService() {
            _classCallCheck(this, JourneyService);
        }

        _createClass(JourneyService, [{
            key: "fetchJourneyHeaders",
            value: function fetchJourneyHeaders(policyId, coverStartDate, coverEndDate, coverCancelledDate, brokerPolicyId, brokerPolicyHolderId, policyholderFullName, journeyId) {
                var _this = this;

                return journeyController.fetchJourneyHeaders({
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate,
                    coverCancelledDate: coverCancelledDate,
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: brokerPolicyId,
                    brokerPolicyHolderId: brokerPolicyHolderId,
                    policyHolderFullName: policyholderFullName,
                    journeyId: journeyId
                }).fail(function (e) {
                    return _this.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "checkRebuildStatus",
            value: function checkRebuildStatus(policyId, journeyId, newVersion) {
                var _this2 = this;

                return journeyController.checkRebuildStatus({
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    journeyId: journeyId,
                    newJourneyVersion: newVersion,
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this2.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "fetchJourneyHeadersBetweenDates",
            value: function fetchJourneyHeadersBetweenDates(policyId, startDate, endDate) {
                var _this3 = this;

                return journeyController.fetchJourneyHeadersBetweenDates({
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    startDate: moment(startDate).toISOString(),
                    endDate: moment(endDate).toISOString(),
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this3.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "fetchDayJourneyForJourneyId",
            value: function fetchDayJourneyForJourneyId(policyId, journeyId) {
                var _this4 = this;

                return journeyController.fetchDayJourneyForJourneyId({
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    journeyId: journeyId,
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this4.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "fetchMoreJourneyHeaders",
            value: function fetchMoreJourneyHeaders(policyId, startDate, endDate, direction, brokerPolicyId, brokerPolicyHolderId, policyholderFullName) {
                var _this5 = this;

                return journeyController.fetchMoreJourneyHeaders({
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    startDate: startDate,
                    endDate: endDate,
                    direction: direction,
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: brokerPolicyId,
                    brokerPolicyHolderId: brokerPolicyHolderId,
                    policyHolderFullName: policyholderFullName
                }).fail(function (e) {
                    return _this5.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "fetchVersion1Journey",
            value: function fetchVersion1Journey(imei, journeyId) {
                var _this6 = this;

                return journeyController.fetchVersion1Journey({
                    environment: this.getEnvironment(),
                    imei: imei,
                    journeyId: journeyId,
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this6.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "fetchLayers",
            value: function fetchLayers(policyId, journeyId, version, layers) {
                return journeyController.fetchLayers({
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    journeyId: journeyId,
                    insurerId: userIdentityModel.insurerId(),
                    version: version,
                    layers: layers
                });
            }
        }, {
            key: "cloneJourney",
            value: function cloneJourney(imei, journeyId) {
                return journeyController.cloneJourney({
                    environment: this.getEnvironment(),
                    journeyId: journeyId,
                    imei: imei
                });
            }
        }, {
            key: "checkIfLinkIsBlacklisted",
            value: function checkIfLinkIsBlacklisted(linkId) {
                return journeyController.checkIfLinkIsBlacklisted({
                    insurerId: userIdentityModel.insurerId(),
                    environment: this.getEnvironment(),
                    linkId: linkId
                });
            }
        }, {
            key: "fetchHomelatLng",
            value: function fetchHomelatLng(policyId, addressLine1, addressLine2, addressLine3, addressLine4, postCode) {
                var _this7 = this;

                return journeyController.fetchHomelatLng({
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    addressLine1: addressLine1,
                    addressLine2: addressLine2,
                    addressLine3: addressLine3,
                    addressLine4: addressLine4,
                    postcode: postCode,
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this7.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "checkSpeedChallenges",
            value: function checkSpeedChallenges(policyId) {
                return journeyController.checkSpeedChallenges({
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    insurerId: userIdentityModel.insurerId()
                });
            }
        }, {
            key: "refreshJourneyHeader",
            value: function refreshJourneyHeader(policyId, coverStartDate, coverEndDate, coverCancelledDate, journeyHeader) {
                return journeyController.fetchSingleJourneyHeader({
                    insurerId: userIdentityModel.insurerId(),
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    journeyId: journeyHeader.journeyId,
                    journeyStartDate: journeyHeader.start(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate,
                    coverCancelledDate: coverCancelledDate
                });
            }
        }, {
            key: "deleteVersion3Journey",
            value: function deleteVersion3Journey(policyId, journeyStartDate, journeyId) {
                var request = {
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    journeyStartDate: journeyStartDate,
                    journeyId: journeyId
                };
                return journeyController.deleteVersion3Journey(Object.assign(Object.assign({}, request), policyViewModel.getSentinelLogPolicyDetails()));
            }
        }, {
            key: "undeleteVersion3Journey",
            value: function undeleteVersion3Journey(policyId, journeyStartDate, journeyId) {
                var request = {
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    journeyStartDate: journeyStartDate,
                    journeyId: journeyId
                };
                return journeyController.undeleteVersion3Journey(Object.assign(Object.assign({}, request), policyViewModel.getSentinelLogPolicyDetails()));
            }
        }, {
            key: "requestJourneyClean",
            value: function requestJourneyClean(rebuildJourneyRequest) {
                rebuildJourneyRequest.environment = this.getEnvironment();
                return journeyController.requestJourneyClean(rebuildJourneyRequest);
            }
        }, {
            key: "requestScoreRebuild",
            value: function requestScoreRebuild(rebuildSummaryRequest) {
                rebuildSummaryRequest.environment = this.getEnvironment();
                return journeyController.requestScoreRebuild(rebuildSummaryRequest);
            }
        }, {
            key: "loadJourneySummaryFail",
            value: function loadJourneySummaryFail(e) {}
        }, {
            key: "getEnvironment",
            value: function getEnvironment() {
                return mainRouter.router.environmentId();
            }
        }, {
            key: "getJourneyMileageSummary",
            value: function getJourneyMileageSummary(brokerPolicyId, policyId, policyStartDate, policyEndDate) {
                var _this8 = this;

                return journeyController.getJourneyMileageSummary({
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: brokerPolicyId,
                    environment: this.getEnvironment(),
                    searchStartDate: policyStartDate,
                    searchEndDate: policyEndDate
                }).fail(function (e) {
                    return _this8.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "cleanBetweenDates",
            value: function cleanBetweenDates(policyId, startDate, endDate) {
                var request = {
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    startDate: startDate,
                    endDate: endDate
                };
                return journeyController.cleanBetweenDates(Object.assign(Object.assign({}, request), policyViewModel.getSentinelLogPolicyDetails()));
            }
        }, {
            key: "deletePolicyJourney",
            value: function deletePolicyJourney(policyId, brokerPolicyId, brokerPolicyholderId, policyholderFullName, journeyVersionViewModel, selectedVersion, isSoftDelete) {
                return journeyController.deletePolicyJourney({
                    insurerId: userIdentityModel.insurerId(),
                    environment: this.getEnvironment(),
                    journeyId: journeyVersionViewModel.journeyId(),
                    policyId: policyId,
                    isSoftDelete: isSoftDelete,
                    imei: journeyVersionViewModel.imei(),
                    version: selectedVersion,
                    journeyStartDate: journeyVersionViewModel.start().toISOString(),
                    journeyEndDate: journeyVersionViewModel.end().toISOString(),
                    brokerPolicyId: brokerPolicyId,
                    brokerPolicyHolderId: brokerPolicyholderId,
                    policyHolderFullName: policyholderFullName
                });
            }
        }, {
            key: "restoreDeletedPolicyJourney",
            value: function restoreDeletedPolicyJourney(policyId, brokerPolicyId, brokerPolicyholderId, policyholderFullName, journeyVersionViewModel, version) {
                return journeyController.restorePolicyJourney({
                    insurerId: userIdentityModel.insurerId(),
                    environment: this.getEnvironment(),
                    journeyId: journeyVersionViewModel.journeyId(),
                    policyId: policyId,
                    imei: journeyVersionViewModel.imei(),
                    version: version,
                    journeyStartDate: journeyVersionViewModel.start().toISOString(),
                    journeyEndDate: journeyVersionViewModel.end().toISOString(),
                    brokerPolicyId: brokerPolicyId,
                    brokerPolicyHolderId: brokerPolicyholderId,
                    policyHolderFullName: policyholderFullName
                });
            }
        }, {
            key: "sendRebuildFromDateRequest",
            value: function sendRebuildFromDateRequest(policy, date, fetchRoadData, brokerPolicyHolderId, policyHolderFullName) {
                return journeyController.sendRebuildFromDateRequest({
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: policy.brokerPolicyId,
                    policyId: policy.id,
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: policy.coverStartDate,
                    coverEndDate: policy.coverEndDate,
                    date: date,
                    fetchRoadData: fetchRoadData,
                    brokerPolicyHolderId: brokerPolicyHolderId,
                    policyHolderFullName: policyHolderFullName
                }).fail(function (e) {});
            }
        }, {
            key: "rebuildDevelopmentLayerJourney",
            value: function rebuildDevelopmentLayerJourney(policyId, brokerPolicyId, brokerPolicyholderId, policyholderFullName, journeyHeader, selectedVersion, isRoadDataLayer, isFluxScoreLayer) {
                return journeyController.rebuildDevelopmentLayerJourney({
                    insurerId: userIdentityModel.insurerId(),
                    environment: this.getEnvironment(),
                    journeyId: journeyHeader.journeyId,
                    policyId: policyId,
                    imei: journeyHeader.imei,
                    version: selectedVersion,
                    journeyStartDate: journeyHeader.start(),
                    journeyEndDate: journeyHeader.end(),
                    brokerPolicyId: brokerPolicyId,
                    brokerPolicyHolderId: brokerPolicyholderId,
                    policyHolderFullName: policyholderFullName,
                    isFluxScoreLayer: isFluxScoreLayer,
                    isRoadDataLayer: isRoadDataLayer
                });
            }
        }, {
            key: "getLinkInfo",
            value: function getLinkInfo(lat, lng) {
                return journeyController.getLinkInfo({
                    environment: this.getEnvironment(),
                    lat: lat,
                    lng: lng
                });
            }
        }, {
            key: "getMatchRoute",
            value: function getMatchRoute(coordArray) {
                return journeyController.getMatchRoute({
                    environment: this.getEnvironment(),
                    points: coordArray
                });
            }
        }, {
            key: "getJourneyStats",
            value: function getJourneyStats(policyId) {
                return journeyController.getJourneyStats(this.getEnvironment(), policyId);
            }
        }, {
            key: "loadJourneySummaryForAccidents",
            value: function loadJourneySummaryForAccidents(brokerPolicyId, policyId, dateString) {
                var _this9 = this;

                return journeyController.getJourneySummaryForDate({
                    environment: this.getEnvironment(),
                    brokerPolicyId: brokerPolicyId,
                    policyId: policyId,
                    date: dateString,
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this9.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "getVehicleLocation",
            value: function getVehicleLocation(brokerPolicyId, policyId) {
                var _this10 = this;

                return journeyController.getVehicleLocation({
                    environment: this.getEnvironment(),
                    brokerPolicyId: brokerPolicyId,
                    policyId: policyId,
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this10.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "getRealTimeAssistanceRequests",
            value: function getRealTimeAssistanceRequests(brokerPolicyId, policyId) {
                var _this11 = this;

                return journeyController.getRealTimeAssistanceRequests({
                    environment: this.getEnvironment(),
                    brokerPolicyId: brokerPolicyId,
                    policyId: policyId,
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this11.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "getRealTimeImpacts",
            value: function getRealTimeImpacts(brokerPolicyId, policyId) {
                var _this12 = this;

                return journeyController.getRealTimeImpacts({
                    environment: this.getEnvironment(),
                    brokerPolicyId: brokerPolicyId,
                    policyId: policyId,
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this12.loadJourneySummaryFail(e);
                });
            }
        }, {
            key: "rebuildJourney",
            value: function rebuildJourney(journeyRebuildModel) {
                journeyRebuildModel.environment = mainRouter.router.environmentId();
                journeyRebuildModel.insurerId = userIdentityModel.insurerId();
                return journeyController.rebuildJourney(journeyRebuildModel);
            }
        }, {
            key: "journeyViewed",
            value: function journeyViewed(journeyViewedRequest) {
                journeyViewedRequest.environment = mainRouter.router.environmentId();
                journeyViewedRequest.insurerId = userIdentityModel.insurerId();
                return journeyController.journeyViewed(journeyViewedRequest);
            }
        }]);

        return JourneyService;
    }();

    var journeyService;
    journeyService = new JourneyService();
    return journeyService;
});
//# sourceMappingURL=journeyService.js.map;
